import {XmlTagInfo} from "../../xmlTagProvider";
import {DragSourceView} from "../../../ui/items/dragdrop/dragSourceView";
import Cell from "../../form/cell";
import {Form} from "../../form/form";
import {Questionary} from "../../questionary";
import {DragItem, DragValue} from "./dragItem";

export class DragSourceItem extends DragItem {
    private _value: number;

    static fromXml(config: XmlTagInfo) {
        return new DragSourceItem(config);
    }

    constructor(config: XmlTagInfo) {
        super(config);
        this._value = parseInt(config.attributes['value'], 10);
    }

    init(questionary: Questionary, form: Form, cell: Cell) {
        super.init(questionary, form, cell);
        this.view = new DragSourceView({cellItem: this});
        this.registerEvents(this.dragGroup);
    }

    resourcesToPreload() {
        return this.getSimpleContentResources(this.childrenTags);
    }

    get value(): number {
        return this._value;
    }

    createDragValue(): DragValue {
        return new DragValue(this);
    }
}